import { render, staticRenderFns } from "./InstallationPage.vue?vue&type=template&id=9697fc9a&scoped=true&"
import script from "./InstallationPage.vue?vue&type=script&lang=js&"
export * from "./InstallationPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9697fc9a",
  null
  
)

export default component.exports